import { IdeaStatus } from "./types";

export interface IdeaStatusStyle {
  bg: string;
  text: string;
  dot: string;
  border: string;
  label: string;
}

export const IDEA_STATUS_CONFIG: Record<IdeaStatus, IdeaStatusStyle> = {
  DRAFT: { bg: "bg-slate-100", text: "text-slate-600", dot: "bg-slate-400", border: "border-slate-200", label: "Bozza" },
  PENDING: { bg: "bg-amber-50", text: "text-amber-700", dot: "bg-amber-500", border: "border-amber-200", label: "In attesa" },
  APPROVED: { bg: "bg-emerald-50", text: "text-emerald-700", dot: "bg-emerald-500", border: "border-emerald-200", label: "Approvata" },
  READY: { bg: "bg-violet-50", text: "text-violet-700", dot: "bg-violet-500", border: "border-violet-200", label: "Pronta" },
  REJECTED: { bg: "bg-rose-50", text: "text-rose-700", dot: "bg-rose-500", border: "border-rose-200", label: "Rifiutata" },
  COMPLETE: { bg: "bg-sky-50", text: "text-sky-700", dot: "bg-sky-500", border: "border-sky-200", label: "Completata" },
};
